import React from 'react';
import { CurrencyUtils, TranslationUtils } from '../../utils';
import { ReceiptLineSummary } from './ReceiptLineSummary';
import { TripAdjustmentResponse } from 'guest-data-types-ts-lib';
import { ExtendStayPreviewRequest, TripAdjustmentPreviewResponse } from 'guest-data-types-ts-lib/types/adjustments';

interface ReceiptLineOccupancyProps {
    preview: TripAdjustmentResponse;
    locale: string;
}

export const ReceiptLineLateCheckOutAdjustment: React.FC<ReceiptLineOccupancyProps> = (props) => {
    const { preview, locale } = props;
    const { delta } = preview;
    const text = TranslationUtils.get('payment_form_add_late_check_out');

    return (
        <>
            <ReceiptLineSummary
                summaryTitle={text}
                summaryValue={CurrencyUtils.formatCurrency(delta.total, delta.currency)}
                currency={delta.currency}
                locale={locale}
            />
            <hr className={'detail-separator'} />
        </>
    );
};
